import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CloseFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22ZM10.3837 8.61625C10.148 8.38855 9.83224 8.26256 9.5045 8.26541C9.17675 8.26826 8.86324 8.39972 8.63148 8.63148C8.39972 8.86324 8.26826 9.17675 8.26541 9.5045C8.26256 9.83224 8.38855 10.148 8.61625 10.3837L10.2325 12L8.61625 13.6163C8.49686 13.7316 8.40163 13.8695 8.33612 14.022C8.27061 14.1745 8.23613 14.3385 8.23469 14.5045C8.23324 14.6705 8.26487 14.8351 8.32772 14.9887C8.39057 15.1423 8.48339 15.2819 8.60076 15.3992C8.71812 15.5166 8.85769 15.6094 9.01131 15.6723C9.16493 15.7351 9.32953 15.7668 9.4955 15.7653C9.66148 15.7639 9.8255 15.7294 9.97801 15.6639C10.1305 15.5984 10.2684 15.5031 10.3837 15.3837L12 13.7675L13.6163 15.3837C13.852 15.6114 14.1678 15.7374 14.4955 15.7346C14.8232 15.7317 15.1368 15.6003 15.3685 15.3685C15.6003 15.1368 15.7317 14.8232 15.7346 14.4955C15.7374 14.1678 15.6114 13.852 15.3837 13.6163L13.7675 12L15.3837 10.3837C15.6114 10.148 15.7374 9.83224 15.7346 9.5045C15.7317 9.17675 15.6003 8.86324 15.3685 8.63148C15.1368 8.39972 14.8232 8.26826 14.4955 8.26541C14.1678 8.26256 13.852 8.38855 13.6163 8.61625L12 10.2325L10.3837 8.61625Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CloseFilledIcon.displayName = 'CloseFilledIcon';
